/**
 * O cliente da única rota que faz nascer um parecer.
 *
 * Ela é separada do `generateCompleteDashboard` de propósito. Até esta onda,
 * pedir o parecer era regerar o dashboard inteiro — e essa é a rota que a tela
 * chama a cada carregamento de página, a cada mês fechado e a cada correção.
 * O parecer renascia sozinho, gastando modelo por recarregamento, e por isso
 * nunca podia dizer que havia sido escrito sobre números que mudaram.
 *
 * Aqui o gasto é sempre de um clique humano. O servidor lê a série por conta
 * própria: o corpo vai vazio porque a impressão digital gravada junto do
 * parecer precisa descrever o que foi REALMENTE analisado, e não o que o
 * navegador diz ter.
 */

import { API_ENDPOINTS } from '../config/api';

export const gerarParecer = async () => {
  const resposta = await fetch(API_ENDPOINTS.INSIGHTS_PARECER, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include'
  });

  const corpo = await resposta.json().catch(() => ({}));
  if (!resposta.ok || corpo.success === false) {
    throw new Error(corpo.message || 'Não foi possível gerar o parecer agora.');
  }
  return corpo.data || {};
};

export default gerarParecer;
